import { ProfileIcon } from "../../../../assets";
import styles from "./style.module.css";

export const MyAccount = () => {
  return (
    <div className={styles.container}>
      <ProfileIcon className={styles.icon} />
      My Account
    </div>
  );
};
